import { Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';
import { INVITATION_MERGE_TAG_PATTERN } from '../constants/invitationTemplateVariables';

/**
 * Pastes invitation merge tags as plain text so TipTap does not wrap them in rich formatting.
 */
export const invitationVariablePasteExtension = Extension.create({
  name: 'invitationVariablePaste',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handlePaste: (view, event) => {
            const plain = event.clipboardData?.getData('text/plain')?.trim();
            if (!plain || !INVITATION_MERGE_TAG_PATTERN.test(plain)) {
              return false;
            }

            event.preventDefault();
            const { from, to } = view.state.selection;
            view.dispatch(view.state.tr.insertText(plain, from, to));
            return true;
          },
        },
      }),
    ];
  },
});
